module.exports = __webpack_public_path__ + "static/media/muzik_gema.60c0a48b.png";